import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type PhoneInputProps = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
};

export type CountryOption = {
  code: string;
  dialCode: string;
  flag: string;
};

export const COUNTRY_OPTIONS: CountryOption[] = [
  { code: 'AF', dialCode: '+93', flag: '🇦🇫' },
  { code: 'AL', dialCode: '+355', flag: '🇦🇱' },
  { code: 'DZ', dialCode: '+213', flag: '🇩🇿' },
  { code: 'AS', dialCode: '+1684', flag: '🇦🇸' },
  { code: 'AD', dialCode: '+376', flag: '🇦🇩' },
  { code: 'AO', dialCode: '+244', flag: '🇦🇴' },
  { code: 'AI', dialCode: '+1264', flag: '🇦🇮' },
  { code: 'AQ', dialCode: '+672', flag: '🇦🇶' },
  { code: 'AG', dialCode: '+1268', flag: '🇦🇬' },
  { code: 'AR', dialCode: '+54', flag: '🇦🇷' },
  { code: 'AM', dialCode: '+374', flag: '🇦🇲' },
  { code: 'AW', dialCode: '+297', flag: '🇦🇼' },
  { code: 'AU', dialCode: '+61', flag: '🇦🇺' },
  { code: 'AT', dialCode: '+43', flag: '🇦🇹' },
  { code: 'AZ', dialCode: '+994', flag: '🇦🇿' },
  { code: 'BS', dialCode: '+1242', flag: '🇧🇸' },
  { code: 'BH', dialCode: '+973', flag: '🇧🇭' },
  { code: 'BD', dialCode: '+880', flag: '🇧🇩' },
  { code: 'BB', dialCode: '+1246', flag: '🇧🇧' },
  { code: 'BY', dialCode: '+375', flag: '🇧🇾' },
  { code: 'BE', dialCode: '+32', flag: '🇧🇪' },
  { code: 'BZ', dialCode: '+501', flag: '🇧🇿' },
  { code: 'BJ', dialCode: '+229', flag: '🇧🇯' },
  { code: 'BM', dialCode: '+1441', flag: '🇧🇲' },
  { code: 'BT', dialCode: '+975', flag: '🇧🇹' },
  { code: 'BO', dialCode: '+591', flag: '🇧🇴' },
  { code: 'BA', dialCode: '+387', flag: '🇧🇦' },
  { code: 'BW', dialCode: '+267', flag: '🇧🇼' },
  { code: 'BR', dialCode: '+55', flag: '🇧🇷' },
  { code: 'IO', dialCode: '+246', flag: '🇮🇴' },
  { code: 'VG', dialCode: '+1284', flag: '🇻🇬' },
  { code: 'BN', dialCode: '+673', flag: '🇧🇳' },
  { code: 'BG', dialCode: '+359', flag: '🇧🇬' },
  { code: 'BF', dialCode: '+226', flag: '🇧🇫' },
  { code: 'BI', dialCode: '+257', flag: '🇧🇮' },
  { code: 'KH', dialCode: '+855', flag: '🇰🇭' },
  { code: 'CM', dialCode: '+237', flag: '🇨🇲' },
  { code: 'CA', dialCode: '+1', flag: '🇨🇦' },
  { code: 'CV', dialCode: '+238', flag: '🇨🇻' },
  { code: 'KY', dialCode: '+1345', flag: '🇰🇾' },
  { code: 'CF', dialCode: '+236', flag: '🇨🇫' },
  { code: 'TD', dialCode: '+235', flag: '🇹🇩' },
  { code: 'CL', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CN', dialCode: '+86', flag: '🇨🇳' },
  { code: 'CX', dialCode: '+61', flag: '🇨🇽' },
  { code: 'CC', dialCode: '+61', flag: '🇨🇨' },
  { code: 'CO', dialCode: '+57', flag: '🇨🇴' },
  { code: 'KM', dialCode: '+269', flag: '🇰🇲' },
  { code: 'CD', dialCode: '+243', flag: '🇨🇩' },
  { code: 'CG', dialCode: '+242', flag: '🇨🇬' },
  { code: 'CK', dialCode: '+682', flag: '🇨🇰' },
  { code: 'CR', dialCode: '+506', flag: '🇨🇷' },
  { code: 'CI', dialCode: '+225', flag: '🇨🇮' },
  { code: 'HR', dialCode: '+385', flag: '🇭🇷' },
  { code: 'CU', dialCode: '+53', flag: '🇨🇺' },
  { code: 'CW', dialCode: '+599', flag: '🇨🇼' },
  { code: 'CY', dialCode: '+357', flag: '🇨🇾' },
  { code: 'CZ', dialCode: '+420', flag: '🇨🇿' },
  { code: 'DK', dialCode: '+45', flag: '🇩🇰' },
  { code: 'DJ', dialCode: '+253', flag: '🇩🇯' },
  { code: 'DM', dialCode: '+1767', flag: '🇩🇲' },
  { code: 'DO', dialCode: '+1809', flag: '🇩🇴' },
  { code: 'EC', dialCode: '+593', flag: '🇪🇨' },
  { code: 'EG', dialCode: '+20', flag: '🇪🇬' },
  { code: 'SV', dialCode: '+503', flag: '🇸🇻' },
  { code: 'GQ', dialCode: '+240', flag: '🇬🇶' },
  { code: 'ER', dialCode: '+291', flag: '🇪🇷' },
  { code: 'EE', dialCode: '+372', flag: '🇪🇪' },
  { code: 'SZ', dialCode: '+268', flag: '🇸🇿' },
  { code: 'ET', dialCode: '+251', flag: '🇪🇹' },
  { code: 'FK', dialCode: '+500', flag: '🇫🇰' },
  { code: 'FO', dialCode: '+298', flag: '🇫🇴' },
  { code: 'FJ', dialCode: '+679', flag: '🇫🇯' },
  { code: 'FI', dialCode: '+358', flag: '🇫🇮' },
  { code: 'FR', dialCode: '+33', flag: '🇫🇷' },
  { code: 'GF', dialCode: '+594', flag: '🇬🇫' },
  { code: 'PF', dialCode: '+689', flag: '🇵🇫' },
  { code: 'GA', dialCode: '+241', flag: '🇬🇦' },
  { code: 'GM', dialCode: '+220', flag: '🇬🇲' },
  { code: 'GE', dialCode: '+995', flag: '🇬🇪' },
  { code: 'DE', dialCode: '+49', flag: '🇩🇪' },
  { code: 'GH', dialCode: '+233', flag: '🇬🇭' },
  { code: 'GI', dialCode: '+350', flag: '🇬🇮' },
  { code: 'GR', dialCode: '+30', flag: '🇬🇷' },
  { code: 'GL', dialCode: '+299', flag: '🇬🇱' },
  { code: 'GD', dialCode: '+1473', flag: '🇬🇩' },
  { code: 'GP', dialCode: '+590', flag: '🇬🇵' },
  { code: 'GU', dialCode: '+1671', flag: '🇬🇺' },
  { code: 'GT', dialCode: '+502', flag: '🇬🇹' },
  { code: 'GG', dialCode: '+44', flag: '🇬🇬' },
  { code: 'GN', dialCode: '+224', flag: '🇬🇳' },
  { code: 'GW', dialCode: '+245', flag: '🇬🇼' },
  { code: 'GY', dialCode: '+592', flag: '🇬🇾' },
  { code: 'HT', dialCode: '+509', flag: '🇭🇹' },
  { code: 'HN', dialCode: '+504', flag: '🇭🇳' },
  { code: 'HK', dialCode: '+852', flag: '🇭🇰' },
  { code: 'HU', dialCode: '+36', flag: '🇭🇺' },
  { code: 'IS', dialCode: '+354', flag: '🇮🇸' },
  { code: 'IN', dialCode: '+91', flag: '🇮🇳' },
  { code: 'ID', dialCode: '+62', flag: '🇮🇩' },
  { code: 'IR', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IQ', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IE', dialCode: '+353', flag: '🇮🇪' },
  { code: 'IM', dialCode: '+44', flag: '🇮🇲' },
  { code: 'IL', dialCode: '+972', flag: '🇮🇱' },
  { code: 'IT', dialCode: '+39', flag: '🇮🇹' },
  { code: 'JM', dialCode: '+1876', flag: '🇯🇲' },
  { code: 'JP', dialCode: '+81', flag: '🇯🇵' },
  { code: 'JE', dialCode: '+44', flag: '🇯🇪' },
  { code: 'JO', dialCode: '+962', flag: '🇯🇴' },
  { code: 'KZ', dialCode: '+7', flag: '🇰🇿' },
  { code: 'KE', dialCode: '+254', flag: '🇰🇪' },
  { code: 'KI', dialCode: '+686', flag: '🇰🇮' },
  { code: 'XK', dialCode: '+383', flag: '🇽🇰' },
  { code: 'KW', dialCode: '+965', flag: '🇰🇼' },
  { code: 'KG', dialCode: '+996', flag: '🇰🇬' },
  { code: 'LA', dialCode: '+856', flag: '🇱🇦' },
  { code: 'LV', dialCode: '+371', flag: '🇱🇻' },
  { code: 'LB', dialCode: '+961', flag: '🇱🇧' },
  { code: 'LS', dialCode: '+266', flag: '🇱🇸' },
  { code: 'LR', dialCode: '+231', flag: '🇱🇷' },
  { code: 'LY', dialCode: '+218', flag: '🇱🇾' },
  { code: 'LI', dialCode: '+423', flag: '🇱🇮' },
  { code: 'LT', dialCode: '+370', flag: '🇱🇹' },
  { code: 'LU', dialCode: '+352', flag: '🇱🇺' },
  { code: 'MO', dialCode: '+853', flag: '🇲🇴' },
  { code: 'MK', dialCode: '+389', flag: '🇲🇰' },
  { code: 'MG', dialCode: '+261', flag: '🇲🇬' },
  { code: 'MW', dialCode: '+265', flag: '🇲🇼' },
  { code: 'MY', dialCode: '+60', flag: '🇲🇾' },
  { code: 'MV', dialCode: '+960', flag: '🇲🇻' },
  { code: 'ML', dialCode: '+223', flag: '🇲🇱' },
  { code: 'MT', dialCode: '+356', flag: '🇲🇹' },
  { code: 'MH', dialCode: '+692', flag: '🇲🇭' },
  { code: 'MQ', dialCode: '+596', flag: '🇲🇶' },
  { code: 'MR', dialCode: '+222', flag: '🇲🇷' },
  { code: 'MU', dialCode: '+230', flag: '🇲🇺' },
  { code: 'YT', dialCode: '+262', flag: '🇾🇹' },
  { code: 'MX', dialCode: '+52', flag: '🇲🇽' },
  { code: 'FM', dialCode: '+691', flag: '🇫🇲' },
  { code: 'MD', dialCode: '+373', flag: '🇲🇩' },
  { code: 'MC', dialCode: '+377', flag: '🇲🇨' },
  { code: 'MN', dialCode: '+976', flag: '🇲🇳' },
  { code: 'ME', dialCode: '+382', flag: '🇲🇪' },
  { code: 'MS', dialCode: '+1664', flag: '🇲🇸' },
  { code: 'MA', dialCode: '+212', flag: '🇲🇦' },
  { code: 'MZ', dialCode: '+258', flag: '🇲🇿' },
  { code: 'MM', dialCode: '+95', flag: '🇲🇲' },
  { code: 'NA', dialCode: '+264', flag: '🇳🇦' },
  { code: 'NR', dialCode: '+674', flag: '🇳🇷' },
  { code: 'NP', dialCode: '+977', flag: '🇳🇵' },
  { code: 'NL', dialCode: '+31', flag: '🇳🇱' },
  { code: 'NC', dialCode: '+687', flag: '🇳🇨' },
  { code: 'NZ', dialCode: '+64', flag: '🇳🇿' },
  { code: 'NI', dialCode: '+505', flag: '🇳🇮' },
  { code: 'NE', dialCode: '+227', flag: '🇳🇪' },
  { code: 'NG', dialCode: '+234', flag: '🇳🇬' },
  { code: 'NU', dialCode: '+683', flag: '🇳🇺' },
  { code: 'NF', dialCode: '+672', flag: '🇳🇫' },
  { code: 'KP', dialCode: '+850', flag: '🇰🇵' },
  { code: 'MP', dialCode: '+1670', flag: '🇲🇵' },
  { code: 'NO', dialCode: '+47', flag: '🇳🇴' },
  { code: 'OM', dialCode: '+968', flag: '🇴🇲' },
  { code: 'PK', dialCode: '+92', flag: '🇵🇰' },
  { code: 'PW', dialCode: '+680', flag: '🇵🇼' },
  { code: 'PS', dialCode: '+970', flag: '🇵🇸' },
  { code: 'PA', dialCode: '+507', flag: '🇵🇦' },
  { code: 'PG', dialCode: '+675', flag: '🇵🇬' },
  { code: 'PY', dialCode: '+595', flag: '🇵🇾' },
  { code: 'PE', dialCode: '+51', flag: '🇵🇪' },
  { code: 'PH', dialCode: '+63', flag: '🇵🇭' },
  { code: 'PL', dialCode: '+48', flag: '🇵🇱' },
  { code: 'PT', dialCode: '+351', flag: '🇵🇹' },
  { code: 'PR', dialCode: '+1787', flag: '🇵🇷' },
  { code: 'QA', dialCode: '+974', flag: '🇶🇦' },
  { code: 'RE', dialCode: '+262', flag: '🇷🇪' },
  { code: 'RO', dialCode: '+40', flag: '🇷🇴' },
  { code: 'RU', dialCode: '+7', flag: '🇷🇺' },
  { code: 'RW', dialCode: '+250', flag: '🇷🇼' },
  { code: 'BL', dialCode: '+590', flag: '🇧🇱' },
  { code: 'SH', dialCode: '+290', flag: '🇸🇭' },
  { code: 'KN', dialCode: '+1869', flag: '🇰🇳' },
  { code: 'LC', dialCode: '+1758', flag: '🇱🇨' },
  { code: 'MF', dialCode: '+590', flag: '🇲🇫' },
  { code: 'PM', dialCode: '+508', flag: '🇵🇲' },
  { code: 'VC', dialCode: '+1784', flag: '🇻🇨' },
  { code: 'WS', dialCode: '+685', flag: '🇼🇸' },
  { code: 'SM', dialCode: '+378', flag: '🇸🇲' },
  { code: 'ST', dialCode: '+239', flag: '🇸🇹' },
  { code: 'SA', dialCode: '+966', flag: '🇸🇦' },
  { code: 'SN', dialCode: '+221', flag: '🇸🇳' },
  { code: 'RS', dialCode: '+381', flag: '🇷🇸' },
  { code: 'SC', dialCode: '+248', flag: '🇸🇨' },
  { code: 'SL', dialCode: '+232', flag: '🇸🇱' },
  { code: 'SG', dialCode: '+65', flag: '🇸🇬' },
  { code: 'SX', dialCode: '+1721', flag: '🇸🇽' },
  { code: 'SK', dialCode: '+421', flag: '🇸🇰' },
  { code: 'SI', dialCode: '+386', flag: '🇸🇮' },
  { code: 'SB', dialCode: '+677', flag: '🇸🇧' },
  { code: 'SO', dialCode: '+252', flag: '🇸🇴' },
  { code: 'ZA', dialCode: '+27', flag: '🇿🇦' },
  { code: 'KR', dialCode: '+82', flag: '🇰🇷' },
  { code: 'SS', dialCode: '+211', flag: '🇸🇸' },
  { code: 'ES', dialCode: '+34', flag: '🇪🇸' },
  { code: 'LK', dialCode: '+94', flag: '🇱🇰' },
  { code: 'SD', dialCode: '+249', flag: '🇸🇩' },
  { code: 'SR', dialCode: '+597', flag: '🇸🇷' },
  { code: 'SJ', dialCode: '+47', flag: '🇸🇯' },
  { code: 'SE', dialCode: '+46', flag: '🇸🇪' },
  { code: 'CH', dialCode: '+41', flag: '🇨🇭' },
  { code: 'SY', dialCode: '+963', flag: '🇸🇾' },
  { code: 'TW', dialCode: '+886', flag: '🇹🇼' },
  { code: 'TJ', dialCode: '+992', flag: '🇹🇯' },
  { code: 'TZ', dialCode: '+255', flag: '🇹🇿' },
  { code: 'TH', dialCode: '+66', flag: '🇹🇭' },
  { code: 'TL', dialCode: '+670', flag: '🇹🇱' },
  { code: 'TG', dialCode: '+228', flag: '🇹🇬' },
  { code: 'TK', dialCode: '+690', flag: '🇹🇰' },
  { code: 'TO', dialCode: '+676', flag: '🇹🇴' },
  { code: 'TT', dialCode: '+1868', flag: '🇹🇹' },
  { code: 'TN', dialCode: '+216', flag: '🇹🇳' },
  { code: 'TR', dialCode: '+90', flag: '🇹🇷' },
  { code: 'TM', dialCode: '+993', flag: '🇹🇲' },
  { code: 'TC', dialCode: '+1649', flag: '🇹🇨' },
  { code: 'TV', dialCode: '+688', flag: '🇹🇻' },
  { code: 'UG', dialCode: '+256', flag: '🇺🇬' },
  { code: 'UA', dialCode: '+380', flag: '🇺🇦' },
  { code: 'AE', dialCode: '+971', flag: '🇦🇪' },
  { code: 'GB', dialCode: '+44', flag: '🇬🇧' },
  { code: 'US', dialCode: '+1', flag: '🇺🇸' },
  { code: 'UY', dialCode: '+598', flag: '🇺🇾' },
  { code: 'VI', dialCode: '+1340', flag: '🇻🇮' },
  { code: 'UZ', dialCode: '+998', flag: '🇺🇿' },
  { code: 'VU', dialCode: '+678', flag: '🇻🇺' },
  { code: 'VA', dialCode: '+379', flag: '🇻🇦' },
  { code: 'VE', dialCode: '+58', flag: '🇻🇪' },
  { code: 'VN', dialCode: '+84', flag: '🇻🇳' },
  { code: 'WF', dialCode: '+681', flag: '🇼🇫' },
  { code: 'EH', dialCode: '+212', flag: '🇪🇭' },
  { code: 'YE', dialCode: '+967', flag: '🇾🇪' },
  { code: 'ZM', dialCode: '+260', flag: '🇿🇲' },
  { code: 'ZW', dialCode: '+263', flag: '🇿🇼' },
];


function detectBrowserCountryCode(): string | null {
  try {
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const parts = locale.split('-');
    if (parts.length > 1) {
      return parts[1].toUpperCase();
    }
    return null;
  } catch {
    return null;
  }
}

function findDefaultCountry(): CountryOption {
  const browserCountry = detectBrowserCountryCode();
  if (browserCountry) {
    const match = COUNTRY_OPTIONS.find((c) => c.code === browserCountry);
    if (match) return match;
  }
  return COUNTRY_OPTIONS[0];
}

function parsePhone(value: string): { dialCode: string; number: string } {
  if (!value) {
    return { dialCode: findDefaultCountry().dialCode, number: '' };
  }

  const trimmed = value.trim();
  if (!trimmed.startsWith('+')) {
    return { dialCode: findDefaultCountry().dialCode, number: trimmed };
  }

  const [maybeCode, ...rest] = trimmed.split(/\s+/);
  const match = COUNTRY_OPTIONS.find((c) => c.dialCode === maybeCode);
  if (!match) {
    return { dialCode: findDefaultCountry().dialCode, number: trimmed.replace(maybeCode, '').trim() };
  }

  return {
    dialCode: match.dialCode,
    number: rest.join(' ').trim(),
  };
}

const PhoneInput: React.FC<PhoneInputProps> = ({ id, label, value, onChange }) => {
  const { t } = useTranslation();
  const detectInitialCountryCode = () => {
    const parsed = parsePhone(value);
    const exact = COUNTRY_OPTIONS.find((c) => c.dialCode === parsed.dialCode);
    return exact?.code || findDefaultCountry().code;
  };

  const [countryCode, setCountryCode] = useState(detectInitialCountryCode);
  const [number, setNumber] = useState(() => parsePhone(value).number);

  useEffect(() => {
    const parsed = parsePhone(value);
    const nextCountry = COUNTRY_OPTIONS.find((c) => c.dialCode === parsed.dialCode)?.code;
    if ((nextCountry && nextCountry !== countryCode) || parsed.number !== number) {
      if (nextCountry) setCountryCode(nextCountry);
      setNumber(parsed.number);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleCountryCodeChange = (nextCountryCode: string) => {
    setCountryCode(nextCountryCode);
    const nextCountry =
      COUNTRY_OPTIONS.find((c) => c.code === nextCountryCode) || findDefaultCountry();
    const nextDialCode = nextCountry.dialCode;
    if (number.trim()) {
      onChange(`${nextDialCode} ${number}`.trim());
    }
  };

  const handleNumberChange = (nextNumber: string) => {
    setNumber(nextNumber);
    const trimmed = nextNumber.trim();
    const currentDialCode =
      COUNTRY_OPTIONS.find((c) => c.code === countryCode)?.dialCode
      || findDefaultCountry().dialCode;
    onChange(trimmed ? `${currentDialCode} ${trimmed}` : '');
  };

  return (
    <div className="space-y-1.5 text-sm">
      <label className="block text-xs font-medium text-slate-700" htmlFor={id}>
        {label}
      </label>
      <div className="flex gap-2">
        <select
          value={countryCode}
          onChange={(e) => handleCountryCodeChange(e.target.value)}
          className="w-40 rounded-lg border border-slate-300 bg-white px-2 py-2 text-xs text-slate-900 outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-400/70"
          aria-label={t('auth.country_code_aria', { defaultValue: 'Country code' })}
        >
          {COUNTRY_OPTIONS.map((country) => (
            <option key={country.code} value={country.code}>
              {country.flag} {country.code} ({country.dialCode})
            </option>
          ))}
        </select>
        <input
          id={id}
          type="tel"
          className="flex-1 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none placeholder:text-slate-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-400/70"
          value={number}
          onChange={(e) => handleNumberChange(e.target.value)}
          placeholder={t('auth.phone_number_placeholder', {
            defaultValue: 'Phone number',
          })}
        />
      </div>
    </div>
  );
};

export default PhoneInput;

